export default [
  {
    path: "cockpitDashboard",
    name: "cockpitDashboard",
    meta: {
      title: "仪表盘",
      keepAlive:true,
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitDashboard/index.vue")
  },
  {
    path: "cockpitTarget",
    name: "cockpitTarget",
    meta: {
      title: "目标管理"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitTarget/index.vue")
  },
  {
    path: "setTarget",
    name: "setTarget",
    meta: {
      title: "目标设定"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitTarget/setTarget.vue")
  },
  {
    path: "cockpitPerformanceReview",
    name: "cockpitPerformanceReview",
    meta: {
      title: "业绩复盘"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitPerformanceReview/index.vue")
  },
  {
    path: "cockpitBasicSettings",
    name: "cockpitBasicSettings",
    meta: {
      title: "基础设置"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitBasicSettings/index.vue")
  },
];
